import FreemiumEventCreateRegistrationStep from './FreemiumEventCreateRegistrationStep';

export default FreemiumEventCreateRegistrationStep;
